export default __webpack_public_path__ + "static/media/setion08_kv02_m.00ee248f.png";